import { AxiosResponse } from 'axios';

import client from '../../lib/service/publication.service';
import {
  GeolocationParams,
  PublicationEstablishments,
} from './publication-establishments.types';
import { Publication } from '../publications/publications.types';

type PublicationEstablishmentsResponse = {
  publication_establishments: Publication[];
};

const SET_PUBLICATION_ESTABLISHMENTS = (publicationId: string) =>
  `/v1/publications/${publicationId}/set_publication_establishments`;

const PUBLICATION_ESTABLISHMENTS = (publicationId: string) =>
  `/v1/publications/${publicationId}/publication_establishments`;

const PUBLICATION_ESTABLISHMENTS_LIST = `/v1/publication_establishments`;

export async function setPublicationEstablishments(
  params,
): Promise<PublicationEstablishments[]> {
  const { publication_id, ...body } = params;
  const response = await client.put<
    number[],
    AxiosResponse<PublicationEstablishmentsResponse>
  >(SET_PUBLICATION_ESTABLISHMENTS(publication_id), body);
  return response.data.publication_establishments;
}

export async function getPublicationEstablishments(
  publicationId: string,
  params?: GeolocationParams,
): Promise<PublicationEstablishments[]> {
  const response = await client.get<
    null,
    AxiosResponse<PublicationEstablishmentsResponse>
  >(PUBLICATION_ESTABLISHMENTS(publicationId), { params });
  return response.data.publication_establishments;
}

export async function getPublicationEstablishmentsList(params?: {
  latitude: number;
  longitude: number;
}): Promise<PublicationEstablishments[]> {
  const response = await client.get<
    null,
    AxiosResponse<PublicationEstablishmentsResponse>
  >(PUBLICATION_ESTABLISHMENTS_LIST, { params });
  return response.data.publication_establishments;
}
